<template>
  <div class="samsung text-NotoSansLight mx-auto relative">
    <div class="main w-full">
      <nav class="bg-transparent container max-w-7xl">
        <div class="py-4 lg:py-6 px-4 lg:px-6">
          <nav class="flex items-center">
            <router-link :to="{ name: 'index'}" class="flex items-center mr-6 w-32 lg:w-auto">
              <img src="~@/assets/images/samsung/pic_liveabc_logo.png" class="object-contain max-w-full w-full">
            </router-link>
            <div class="flex items-center text-white justify-start">
              <a class="menu-item cursor-pointer inline-block text-base md:text-lg px-2 py-3" @click="scrollToActivityArea">
                活動專區
              </a>
              <span>|</span>
              <a class="menu-item cursor-pointer inline-block text-base md:text-lg px-2 py-3" @click="scrollToDownload">
                APP下載
              </a>
            </div>
          </nav>
        </div>
      </nav>
      <!-- banner -->
      <div class="eventPal relative lg:mb-10">
        <div class="mask absolute"></div>
        <div class="flex wrap md:h-auto py-3 lg:py-5 px-4 lg:px-10 flex-wrap mx-auto max-w-4xl">
          <div class="item w-2/5 z-10">
            <img src="~@/assets/images/samsung/pic_s6_lite.png" class="object-contain max-w-full" data-aos="slide-right" data-aos-easing="ease" data-aos-once="true">
          </div>
          <div class="item w-3/5 flex flex-col justify-center lg:justify-between flex-shrink flex-2 z-10 pl-2 md:px-8 lg:px-10">
            <div class="py-4 md:py-8 hidden lg:block"></div>
            <div>
              <img src="~@/assets/images/samsung/pic_title_main.png" class="object-contain max-w-full mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
            </div>

            <div class="hidden lg:flex flex-col items-center cursor-pointer" @click="showActivityMethod">
              <p class="text-white mb-4 text-lg tracking-wider font-light">了解活動辦法</p>
              <img src="~@/assets/images/samsung/btn_downArrow.png" class="object-contain">
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col items-center lg:hidden w-full mb-10">
        <a @click="showActivityMethod" class="cursor-pointer">
          <p class="text-white mb-4 text-base tracking-wider font-light">了解活動辦法</p>
          <img src="~@/assets/images/samsung/btn_downArrow.png" class="object-contain mx-auto w-8">
        </a>
      </div>
      <!-- 活動專區 -->
      <div class="area py-8 lg:py-16 max-w-5xl mx-auto px-4 lg:px-6" ref="activityArea">
        <div class="title border-b-2 border-white pb-5 mb-8">
          <img src="~@/assets/images/samsung/pic_title_activity.png" class="object-contain max-w-full mx-auto w-32 md:w-auto">
        </div>

        <!-- BTN -->
        <div class="btns flex mb-8 flex-wrap px-4" data-aos="fade-up" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
          <div class="w-1/2 md:w-1/4">
            <a class="cursor-pointer" @click="tab(0)">
              <img src="~@/assets/images/samsung/btn_01_login.png" class="object-contain max-w-full cursor-pointer" alt="liveABC">
            </a>
          </div>
          <div class="w-1/2 md:w-1/4">
            <a class="cursor-pointer" @click="tab(1)">
              <img src="~@/assets/images/samsung/btn_02_check.png" class="object-contain max-w-full cursor-pointer" alt="liveABC">
            </a>
          </div>
          <div class="w-1/2 md:w-1/4">
            <a class="cursor-pointer" @click="tab(2)">
              <img src="~@/assets/images/samsung/btn_03_info.png" class="object-contain max-w-full cursor-pointer" alt="liveABC">
            </a>
          </div>
          <div class="w-1/2 md:w-1/4">
            <a class="cursor-pointer" @click="tab(3)">
              <img src="~@/assets/images/samsung/btn_04_qa.png" class="object-contain max-w-full cursor-pointer" alt="liveABC">
            </a>
          </div>
        </div>

        <div v-if="active_action !== -1" class="max-w-3xl mx-auto bg-white py-2 lg:p-4 rounded">
          <!-- 立即登錄 -->
          <div v-if="active_action === 0" class="mx-auto max-w-2xl w-full">
            <h5 class="text-purple-samsung font-bold text-2xl text-center mb-4">-&thinsp;立即登錄&thinsp;-</h5>
            <!-- steper -->
            <div class="w-full py-6 max-w-2xl mx-auto">
              <div class="flex">
                <div class="w-1/3">
                  <div class="relative mb-2">
                    <div class="w-8 h-8 mx-auto hasCross rounded-full text-base text-white flex items-center border">
                      <span class="text-center text-white w-full text-NotoSansRegular" v-if="signInStep === 0">
                        1
                      </span>
                      <span class="text-center text-white w-full text-NotoSansRegular" v-if="signInStep === 1 || signInStep === 2">
                        <font-awesome-icon icon="check" class="text-sm" />
                      </span>
                    </div>
                  </div>

                  <div class="text-xs text-center md:text-base textColorDarkBlack">填寫您的購買資料</div>
                </div>

                <div class="w-1/3">
                  <div class="relative mb-2">
                    <div class="absolute flex align-center items-center align-middle content-center" style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
                      <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1" :class="{ activeStep: signInStep === 1, hasCross: signInStep === 2 }">
                        <div class="pt-1 rounded w-full notCross" :class="{ activeStep: signInStep === 1, hasCross: signInStep === 2 }"></div>
                      </div>
                    </div>

                    <div class="w-8 h-8 mx-auto bg-white rounded-full text-base text-white flex items-center border notCross" :class="{ activeStep: signInStep === 1, hasCross: signInStep === 2 }">
                      <span class="text-center w-full text-NotoSansRegular" v-if="signInStep === 0 || signInStep === 1">
                        2
                      </span>
                      <span class="text-center w-full text-NotoSansRegular" v-if="signInStep === 2">
                        <font-awesome-icon icon="check" class="text-sm" />
                      </span>
                    </div>
                  </div>

                  <div class="text-xs text-center md:text-base textColorDarkBlack">確認您填寫的購買資料</div>
                </div>
                <div class="w-1/3">
                  <div class="relative mb-2">
                    <div class="absolute flex align-center items-center align-middle content-center" style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
                      <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1 notCross" :class="{ hasCross: signInStep === 2 }">
                        <div class="w-full pt-1 rounded notCross" :class="{ activeStep: signInStep === 1, hasCross: signInStep === 2 }"></div>
                      </div>
                    </div>

                    <div class="w-8 h-8 mx-auto bg-white rounded-full text-base flex items-center border notCross" :class="{ hasCross: signInStep === 2 }">
                      <span class="text-center w-full text-NotoSansRegular">
                        3
                      </span>
                    </div>
                  </div>

                  <div class="text-xs text-center md:text-base textColorDarkBlack">完成登錄</div>
                </div>
              </div>
            </div>

            <form action="javascript:void(0);" v-if="signInStep !== 2">
              <div class="mx-auto max-w-2xl w-full bg-white rounded py-2 lg:p-4 flex flex-col justify-between leading-normal" ref="form">
                <div class="flex flex-wrap textColorBlack">
                  <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="name">
                    <label class="md:pt-2 text-sm md:text-base md:w-1/5 tracking-wide" for="name">
                      使用者姓名
                    </label>
                    <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full  text-sm border rounded py-3 px-4 leading-tight focus:outline-none bg-white"
                      id="name" type="text" placeholder="請輸入使用者姓名" autocomplete="off" :readonly="signInStep === 1" v-model.trim="signIn.realName" :class="{ disabledInput: signInStep === 1 }">
                  </div>
                  <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="name">
                    <label class="md:pt-2 text-sm md:text-base md:w-1/5 tracking-wide" for="email">
                      E-MAIL
                    </label>
                    <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full  text-sm border rounded py-3 px-4 leading-tight focus:outline-none bg-white"
                      id="email" type="text" placeholder="請輸入E-MAIL" autocomplete="off" :readonly="signInStep === 1" v-model.trim="signIn.email" :class="{ disabledInput: signInStep === 1 }">
                  </div>
                  <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="phone">
                    <label class="md:pt-2 text-sm md:text-base md:w-1/5 tracking-wide" for="phone">
                      行動電話
                    </label>
                    <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full text-sm border rounded py-3 px-4 leading-tight focus:outline-none bg-white"
                      id="phone" type="text" placeholder="請輸入行動電話" autocomplete="off" :readonly="signInStep === 1" v-model.trim="signIn.phone" :class="{ disabledInput: signInStep === 1 }">
                  </div>
                  <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="sn">
                    <label class="md:pt-2 text-sm md:text-base md:w-1/5 tracking-wide" for="sn">
                      S/N
                    </label>
                    <input spellcheck="false" class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full text-sm border rounded py-3 px-4 leading-tight focus:outline-none bg-white"
                      id="sn" type="text" placeholder="請輸入11碼的S/N序號" maxlength="11" autocomplete="off" :readonly="signInStep === 1" v-model.trim="signIn.sn" :class="{ disabledInput: signInStep === 1 }">
                    <div class="md:w-1/5 md:pl-2 pt-2 md:pt-0" v-if="signInStep === 0">
                      <a class="button-gray border rounded focus:outline-none h-full text-xs flex items-center justify-center py-3 md:py-0 cursor-pointer" @click="isShowSN = true">IMEI/SN查詢教學</a>
                    </div>
                  </div>
                  <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="phone" v-if="signInStep === 0 || (signInStep === 1 && signIn.invoice)">
                    <label class="md:pt-2 text-sm md:text-base md:w-1/5 tracking-wide" for="number">
                      發票號碼(選填)
                    </label>
                    <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                      id="number" type="text" autocomplete="off" :readonly="signInStep === 1" v-model.trim="signIn.invoice" :class="{ disabledInput: signInStep === 1 }" maxlength="20">
                  </div>
                  <div class="w-full px-3 mb-2 md:flex pt-2 justify-center" ref="sn" v-if="signInStep === 0">
                    <a class="button-gray border rounded focus:outline-none h-full text-sm flex items-center justify-center py-3 px-16 cursor-pointer" @click="next()">下一步</a>
                  </div>
                  <div class="w-full px-3 mb-2 md:flex pt-2 justify-center" ref="sn" v-if="signInStep === 1">
                    <a class="w-full inline-block md:w-auto text-center button-gray border rounded focus:outline-none md:h-full text-sm items-center justify-center py-3 px-6 mx-1 cursor-pointer mb-2 md:mb-0" @click="signInStep = 0">上一步，修改資料</a>
                    <a class="w-full inline-block md:w-auto text-center text-white bgLiveBlack border rounded focus:outline-none md:h-full text-sm items-center justify-center py-3 px-6 md:px-16 mx-1 cursor-pointer" @click="signInSubmit()">確認無誤</a>
                  </div>
                </div>
              </div>
            </form>
            <div v-if="signInStep === 2 && responseData" class="bg-white px-4 py-5 mx-auto max-w-2xl w-full rounded">
              <ul>
                <li class="mb-2">{{ signIn.realName }}，謝謝您登錄Back to School
                  <span class="font-bold">燦坤Back to School</span>
                  歡慶特別活動</li>
                <li class="mb-2">兌換序號為：<span class="font-bold">{{ responseData.exchangeCode }}</span>
                  <a class="ml-2 px-1 cursor-pointer" @click="copy(responseData.exchangeCode)">
                  <font-awesome-icon :icon="['far', 'copy']" class="text-lg" />
                  </a>
                </li>
                <li class="mb-2">兌換時間為：2020年08月13日~2020年12月31日止</li>
                <li class="mb-2">登錄期間為：{{ moment(responseData.registerTime).add(8, 'hours').format('YYYY年MM月DD日 HH:mm') }}</li>
                <li>詳細兌換方式請見 <a @click="tab(3)" class="underline text-blue-400">Q&amp;A</a></li>
              </ul>
            </div>
          </div>

          <!-- 登錄查詢 -->
          <div v-if="active_action === 1" class="mx-auto max-w-2xl w-full">
            <h5 class="text-purple-samsung font-bold text-2xl text-center mb-4">-&thinsp;登錄查詢&thinsp;-</h5>
            <form action="javascript:void(0);" v-if="checkStep === 0">
              <div class="flex flex-col justify-between leading-normal" ref="form">
                <div class="flex flex-wrap textColorBlack">
                  <!-- 行動電話 -->
                  <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="phone">
                    <label class="md:text-base md:w-1/5 tracking-wide text-sm" for="phone">
                      行動電話
                    </label>
                    <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                      id="phone" type="text" placeholder="請輸入行動電話" autocomplete="off" :readonly="signInStep === 1" v-model.trim="checkArr.phone">
                  </div>
                  <!-- S/N -->
                  <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="sn">
                    <label class="md:text-base md:w-1/5 tracking-wide text-sm" for="sn">
                      S/N
                    </label>
                    <input spellcheck="false" class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                      id="sn" type="text" placeholder="請輸入11碼的S/N序號" maxlength="11" autocomplete="off" v-model.trim="checkArr.sn">
                    <div class="md:w-1/5 md:pl-2 pt-2 md:pt-0">
                      <a class="button-gray border rounded focus:outline-none h-full text-xs flex items-center justify-center py-3 md:py-0 cursor-pointer" @click="isShowSN = true">IMEI/SN查詢教學</a>
                    </div>
                  </div>
                  <div class="w-full px-3 mb-2 md:flex pt-2 justify-center" ref="sn" v-if="checkStep === 0">
                    <a class="button-gray border rounded focus:outline-none h-full text-sm flex items-center justify-center py-3 px-16 cursor-pointer" @click="checkSubmit()">下一步</a>
                  </div>
                </div>
              </div>
            </form>
            <div v-if="checkStep === 1 && responseData" class="bg-white px-4 py-5 mx-auto max-w-2xl w-full rounded">
              <ul>
                <li class="mb-2">兌換序號為：<span class="font-bold">{{ responseData.exchangeCode }}</span><a class="ml-2 px-1 cursor-pointer" @click="copy(responseData.exchangeCode)">
                  <font-awesome-icon :icon="['far', 'copy']" class="text-lg" /></a></li>
                <li class="mb-2">兌換時間為：2020年08月13日~2020年12月31日止</li>
                <li class="mb-2">登錄期間為：{{ moment(responseData.registerTime).add(8, 'hours').format('YYYY年MM月DD日 HH:mm') }}</li>
                <li>詳細兌換方式請見 <a @click="tab(3)" class="underline text-blue-400">Q&amp;A</a>
                </li>
              </ul>
            </div>
          </div>

          <!-- 活動辦法 -->
          <div v-if="active_action === 2" class="scrollBar mx-auto">
            <div class="max-w-3xl px-4">
              <h5 class="text-purple-samsung font-bold text-2xl text-center mb-4">-&thinsp;活動辦法&thinsp;-</h5>
              <h4 class="font-bold text-xl tracking-wider text-NotoSansBold">LiveABC＋SAMSUNG</h4>
              <h5 class="font-bold text-lg tracking-wider mb-1 text-NotoSansBold">燦坤Back to School 歡慶特別活動</h5>
              <h6 class="text-base md:text-lg mb-4 tracking-wider">凡於活動期間(2020/08/13至2020/09/15)至TK3C燦坤通路購買Galaxy Tab S6 Lite，並於2020/12/31前至活動網站完成登錄，登錄完成後即可獲得『Live互動英語』數位雜誌6期兌換序號(市價$780元)。</h6>

              <ul class="list-disc list-inside">
                <li class="mb-2">活動時間：2020/08/13 – 2020/09/15</li>
                <li class="mb-2">登錄時間：2020/08/13 – 2020/12/31</li>
                <li class="mb-2">登錄方式：
                  <ul class="ml-2 list-decimal list-inside">
                    <li class="mb-1 leading-loose">至
                      <a class="underline cursor-pointer text-blue-600" @click="tab(0)">活動網站</a>
                      登錄相關資料。</li>
                    <li class="mb-1 leading-loose">登錄完成後會於活動網頁產生兌換序號，兌換序號會同步寄發到你的電子信箱與傳送簡訊通知。</li>
                    <li class="mb-1 leading-loose">下載並開啟『Live互動英語』APP後，於序號兌換專區填入兌換序號即可完成兌換。</li>
                    <li class="mb-1 leading-loose">完成兌換者，獲得贈送6期免費雜誌。當月雜誌為免費試閱之第1期，未來每期會於每月1號上架。範例：如您於12/15登錄，則可獲得之雜誌為2020/12月號及2021/1~5月號，共6期。</li>
                    <li>若消費者已經購買當期數位雜誌，請於次月1號後再進行兌換，以免重複。</li>
                  </ul>
                </li>
                <li class="mb-2 leading-loose"><span class="font-bold">個人資料保護法告知事項：</span><br/>
                  希伯崙股份有限公司向您蒐集個人資料，蒐集之目的係作為活動聯繫、將來行銷資訊分享以及內部數據分析使用。希伯崙將於蒐集後自行或委託第三人於上述蒐集目的範圍內處理或使用您的個人資料。您可依法向希伯崙請求查詢閱覽、製給複製本、補充更正、停止蒐集處理利用或取消您所提供的個人資料。您也可以選擇不提供個人資料，但您的參加資格可能因程序未完備而喪失。
                </li>
              </ul>

              <router-link target="_blank" :to="{ name: 'privacy'}" class="underline cursor-pointer text-blue-600" :class="{textColorRed: $route.name === 'privacy'}">了解LiveABC隱私權政策</router-link>
            </div>
          </div>

          <!-- QA -->
          <div v-if="active_action === 3" class="scrollBar mx-auto">
            <div class="max-w-3xl px-4">
              <h5 class="text-purple-samsung font-bold text-2xl text-center mb-4">-&thinsp;APP兌換方法&thinsp;-</h5>
              <ul class="pb-10">
                <li class="py-4 border-b borderColorDarkGray" v-for="(item, index) in qaJson" :key="index">
                  <p class="font-black text-NotoSansBold mb-0">0{{ index + 1 }}.</p>
                  <p class="tracking-wider mb-4">{{ item.question }}</p>
                  <img :src="item.img_url" class="mx-auto max-w-full object-contain w-full h-auto" v-if="item.img_url">
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 注意事項 -->
      <div class="attention w-full py-8 lg:py-10">
        <div class="text-NotoSansRegular px-4 max-w-3xl mx-auto">
          <h5 class="text-lg lg:text-xl mb-4 font-bold text-center">-&thinsp;注意事項&thinsp;-</h5>
          <p class="text-base lg:text-lg mb-4">1.&thinsp;僅限燦坤通路購買之Samsung Galaxy Tab S6 Lite機型參與本次活動，其它機種或廠牌之平板或手機將無法兌換。</p>
          <p class="text-base lg:text-lg mb-4">2.&thinsp;登錄完成後，當月雜誌為免費試閱之第1期，未來每期會於每月1號上架。(如您於12/15登錄，則可獲得之雜誌為2020/12月號及2021/1~5月號，共6期。)</p>
          <p class="text-base lg:text-lg mb-4">3.&thinsp;限於2020/8/1~2020/12/31內完成登錄，才可參加本活動。</p>
          <p class="text-base lg:text-lg">4.&thinsp;已兌換的項目限該裝置使用，不得轉換裝置。</p>
        </div>
      </div>
    </div>

    <!-- APP下載 -->
    <div class="download w-full py-12 px-4 md:px-6" ref="download">
      <div class="max-w-5xl mx-auto">
        <div class="area py-12">
          <div class="title border-b-2 border-white pb-5 mb-8">
            <img src="~@/assets/images/samsung/pic_title_appDownload.png" class="object-contain max-w-full mx-auto w-32 md:w-auto">
          </div>

          <div class="app flex mb-8 justify-center px-4">
            <div class="mx-4">
              <a href="https://play.google.com/store/apps/details?id=com.liveabc.mgz.live">
                <img src="~@/assets/images/samsung/pic_appIcon.png" class="object-contain max-w-full" data-aos="fade-right" data-aos-easing="ease" data-aos-once="true">
              </a>
            </div>
            <div class="mx-4">
              <a>
                <img src="~@/assets/images/samsung/pic_qrCode.png" class="object-contain max-w-full" data-aos="fade-left" data-aos-easing="ease" data-aos-once="true">
              </a>
            </div>
          </div>
          <div class="google flex justify-center px-4">
            <a href="https://play.google.com/store/apps/details?id=com.liveabc.mgz.live">
              <img src="~@/assets/images/samsung/pic_googlePlay.png" class="object-contain max-w-full" data-aos="fade-up" data-aos-easing="ease" data-aos-once="true">
            </a>
          </div>
        </div>
      </div>
    </div>

    <footer class="py-8 text-center">
      <div class="max-w-4xl flex flex-wrap justify-center mx-auto">
        <div class="flex flex-col items-center">
          <h6 class="text-lg mb-2 font-bold tracking-wider">CONTACT US</h6>
          <a class="no-underline p-content" href="mailto:service@liveabc.com">
            <p class="no-underline mb-0 p-content-text flex items-center">
              <span class="md:hidden">service@liveabc.com</span>
              <span class="hidden md:inline-block">客服信箱</span>
              <svg focusable="false" data-prefix="far" data-icon="envelope" class="ml-2 h-5 w-5 svg-inline--fa fa-envelope fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path style="fill:#2b6cb0;" fill="#AB7C94;" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z">
                </path>
              </svg>
            </p>
          </a>
          <a class="p-content flex items-center" href="https://lin.ee/wfB4HKN" target="_blank">
            <p class="mb-0 p-content-text items-center flex">
              <span class="">LINE線上客服</span>
            </p>
            <div class="social-icon h-6 w-6 ml-2">
              <img src="@/assets/icon/square-line.png">
            </div>
          </a>
          <div class="p-content">
            <p class="mb-0 p-content-text">
              02-2578-7838</p>
          </div>
          <div class="p-content">
            <p class="mb-0 p-content-text">
              <span>周一至周五  8:30~17:30</span>
            </p>
          </div>
          <router-link :to="{ name: 'index'}"  class="underline p-content">
            <p class="mb-0 p-content-text flex items-center">
              LiveABC官方網站
            </p>
          </router-link>
        </div>
      </div>
    </footer>
    <div class="footer-copyright bg-white">
      <div class="w-full">
        <span class="mx-auto table mb-0 py-4 md:py-6 text-center text-sm">Copyright © 2019 Hebron Soft Limited All Rights Reserved.</span>
      </div>
    </div>
    <!-- popup -->
    <div v-if="isShowSN">
      <div class="popBg" @click="isShowSN = false"></div>

      <div class="popup fixed px-4 max-w-3xl w-full">
        <div class="popup_inner bg-white py-4 px-4 rounded overflow-hidden">
          <div class="flex justify-center mb-4">
            <h3 class="text-xl mx-2">▼手機/平板(LTE版本)</h3>
            <h3 class="text-xl mx-2">IMEI/SN查詢教學</h3>
          </div>
          <div class="flex justify-center mb-3">
            <div class="w-1/2">
              <h3 class="text-lg lg:text-xl text-center">1.手機/平板 通話鍵「*#06#」</h3>
            </div>
            <div class="w-1/2">
              <h3 class="text-lg lg:text-xl text-center">2.若有兩個IMEI碼請以IMEI1碼為主</h3>
            </div>
          </div>
          <div class="flex justify-center">
            <div class="w-1/2 px-2">
              <img src="~@/assets/images/samsung/sn_1.jpg" class="object-contain mx-auto w-full h-auto">
            </div>
            <div class="w-1/2 px-2">
              <img src="~@/assets/images/samsung/sn_2.jpg" class="object-contain mx-auto w-full h-auto">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import axios from 'axios'
import jump from 'jump.js'
import Regex from '@/components/modules/regex'
export default {
  name: 'Samsung',
  metaInfo () {
    return {
      title: 'SamsungP610',
      titleTemplate: null
    }
  },
  data () {
    return {
      isShowSN: false,
      active_action: -1,

      // 立即登錄
      signInStep: 0,
      signIn: {
        realName: null,
        email: null,
        phone: null,
        sn: null,
        invoice: ''
      },

      // 登錄查詢
      checkStep: 0,
      checkArr: {
        phone: null,
        sn: null
      },

      responseData: null,

      qaJson: [
        { question: '下載『Live互動英語』APP', img_url: require('@/assets/images/samsung/info1.jpg') },
        { question: '開啟『Live互動英語』APP，點擊右上方選單，點選序號兌換', img_url: require('@/assets/images/samsung/info2.jpg') },
        { question: '輸入十碼兌換序號(E-mail或手機簡訊取得)', img_url: require('@/assets/images/samsung/info3.jpg') },
        { question: '完成兌換，顯示兌換期間', img_url: require('@/assets/images/samsung/info4.jpg') }
      ]
    }
  },
  components: {
  },
  mixins: [
    Regex
  ],
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    tab (val) {
      let self = this

      if (self.active_action !== val) {
        self.active_action = val
      } else {
        self.active_action = -1
      }
      // reset
      self.$data.signIn = self.$options.data().signIn
      self.$data.checkArr = self.$options.data().checkArr
      self.$data.responseData = self.$options.data().responseData
      self.checkStep = 0
      self.signInStep = 0
    },
    // 立即登錄
    next () {
      let self = this
      if (self.signIn.realName && self.signIn.sn && self.signIn.sn.length === 11 && self.signIn.email && self.signIn.phone && self.rexEmail(self.signIn.email) && self.rexMobile(self.signIn.phone)) {
        self.signInStep = 1
      } else {
        self.$swal.fire({
          icon: 'info',
          title: 'Oops...',
          text: '有欄位還沒填或格式錯誤耶~'
        })
      }
    },
    signInSubmit () {
      let self = this
      if (self.signIn.realName && self.signIn.sn && self.signIn.sn.length === 11 && self.signIn.email && self.signIn.phone && self.rexEmail(self.signIn.email) && self.rexMobile(self.signIn.phone)) {
        // let timerInterval
        self.$swal.fire({
          title: 'Loading',
          timer: 2000,
          timerProgressBar: true,
          onBeforeOpen: () => {
            self.$swal.showLoading()
            axios.post('https://liveabc-samsung.azurewebsites.net/Register', self.signIn)
              .then((response) => {
                self.responseData = response.data
                self.signInStep = 2
                self.$swal.close()
              })
              .catch(() => {
                self.$swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: '登錄失敗...'
                })
              })
          }
        })
      } else {
        self.$swal.fire({
          icon: 'info',
          title: 'Oops...',
          text: '有欄位還沒填或格式錯誤耶~'
        })
      }
    },

    // 登錄查詢
    checkSubmit () {
      let self = this
      if (self.checkArr.sn && self.checkArr.sn.length === 11 && self.checkArr.phone && self.rexMobile(self.checkArr.phone)) {
        self.$swal.fire({
          title: 'Loading',
          timer: 2000,
          timerProgressBar: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          onBeforeOpen: () => {
            self.$swal.showLoading()
            axios.get(`https://liveabc-samsung.azurewebsites.net/Register/Inquire?phone=${self.checkArr.phone}&sn=${self.checkArr.sn}`)
              .then((response) => {
                self.responseData = response.data
                self.checkStep = 1
                self.$swal.close()
              })
              .catch((response) => {
                self.$swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: '查無登錄資料!'
                })
              })
          }
        })
      } else {
        self.$swal.fire({
          icon: 'info',
          title: 'Oops...',
          text: '有欄位還沒填或格式錯誤耶~'
        })
      }
    },
    scrollToActivityArea () {
      let self = this
      jump(self.$refs.activityArea.offsetTop, {
        duration: 800,
        offset: 0
      })
    },
    scrollToDownload () {
      let self = this
      jump(self.$refs.download.offsetTop, {
        duration: 1000,
        offset: 0
      })
    },
    showActivityMethod () {
      let self = this
      self.scrollToActivityArea()
      self.active_action = 2
    },
    copy (val) {
      let self = this
      if (val) {
        self.$copyText(val).then((e) => {
          self.$swal.fire({
            icon: 'success',
            text: '複製成功!',
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.progressive-image-main {
  height: auto !important;
}
// step
.notCross {
  color: #6e64ab !important;
  border-color: #6e64ab;
}
.activeStep {
  background: #6e64ab !important;
  color: white !important;
  border-color: #6e64ab;
}
.hasCross {
  background: #6e64ab !important;
  color: white !important;
  border-color: #6e64ab;
}

.text-purple-samsung {
  color: #6e64ab !important;
}

header {
  top: 0;
  left: 0;
}
.main {
  background-image: url('~@/assets/images/samsung/pic_bg_01.jpg');
  background-position: top center;
  background-repeat: no-repeat;
  background-size:cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-attachment: fixed;
  z-index: -1;
}
.download {
  background-image: url('~@/assets/images/samsung/pic_bg_02.jpg');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
}

.flex-2 {
  flex-grow: 2;
}
.attention {
  background: rgba(255, 255, 255, 0.5);
  color: #484848;
}
.eventPal {
  .mask {
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: 65%;
    width: 100%;
    background: rgba(255, 255, 255, 0.5);
  }
}

.disabledInput {
  border: none !important;
  background: white !important;
}
.noWrap {
  flex-wrap: nowrap !important;
}
// pop
.popBg {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed !important;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.popup {
  width: auto;
  z-index: 9999 !important;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation-name: example;
  animation-duration: .3s;
  animation-fill-mode: forwards;
  .popup_inner {
    img {
      max-height: 30em;
    }
  }
  .btn {
    bottom: 3%;
    right: 5%;
  }
}

@keyframes example {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
    }
}
.scrollBar {
  max-height: 500px;
  overflow-y: scroll;
}
.scrollBar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
}

.scrollBar::-webkit-scrollbar {
  width: 6px;
}

.scrollBar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
footer {
  background-image: url('~@/assets/images/samsung/pic_bg_03.jpg');
  background-size: cover;
  h6 {
    color: #6e64ab;
  }
  .p-content {
    min-height: 32px;
    text-decoration-color: #2b6cb0 !important;
    .p-content-text {
      font-weight: 400;
      line-height: 32px;
      font-size: .875rem;
      color: #2b6cb0;
    }
  }
}
</style>
